package com.neurobs.ccabserver.administrator.components

import com.neurobs.ccabserver.administrator.contexts.{GuiContext, ServerContext, UserContext}
import com.neurobs.react.Button
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks.useState
import slinky.core.facade.ReactElement

@react object RequireDataPassword {
	case class Props
	(
		createWrapped: String => ReactElement
	)
	case class State
	(
		dialogShowing: Boolean,
		passwordSet: Boolean
	)
	val component = FunctionalComponent[Props] { props =>
		val server = ServerContext.accessState()
		val user = UserContext.accessState()
		val accountId = user.user.get.legacyAccountId

		val dataPassword = user.value.dataPasswords.storedValue(accountId)
		val set = dataPassword.nonEmpty

		val (state, setState) = useState(State(dialogShowing = !set, passwordSet = set))

		if (state.dialogShowing) {
			DataPasswordDialog(
				server = server,
				accountId = accountId,
				userAccountId = user.user.get.legacyUserId,
				onFinished = {
					case None => setState(State(dialogShowing = false, passwordSet = false))
					case Some(ps) =>
						user.value.dataPasswords.setValue(accountId = accountId, password = ps)
						setState(State(dialogShowing = false, passwordSet = true))
				}
			)
		}
		else if (state.passwordSet) props.createWrapped(dataPassword.get)
		else Button(caption = "Enter Data Password", onClick = () => setState(State(dialogShowing = true, passwordSet = false)))
	}
}
